import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { fetchApi } from "./redux/api";
import { formatNumber } from "./redux/utils";

// const trialBalanceData = [
//   {
//     sn: 1,
//     description: "Statutory Allocation(FAAC)",
//     debit: "",
//     credit: "XXX",
//   },
//   { sn: 2, description: "Value Added Tax (FAAC)", debit: "", credit: "XXX" },
//   { sn: 3, description: "Other Receipt (FAAC)", debit: "", credit: "XXX" },
//   { sn: 4, description: "Tax Revenue", debit: "", credit: "XXX" },
//   { sn: 5, description: "Othe Revenue", debit: "", credit: "XXX" },
//   { sn: 6, description: "MDAs Revenue", debit: "", credit: "XXX" },
//   { sn: 7, description: "Investment Income", debit: "", credit: "XXX" },
//   {
//     sn: 8,
//     description: "Salaries, wages and employee benefits",
//     debit: "XXX",
//     credit: "",
//   },
//   {
//     sn: 9,
//     description: "Transport and travelling General",
//     debit: "XXX",
//     credit: "",
//   },
//   { sn: 10, description: "Utilities-General", debit: "XXX", credit: "" },
//   { sn: 11, description: "Materials & Supplies", debit: "XXX", credit: "" },
//   { sn: 12, description: "Maintenance Services", debit: "XXX", credit: "" },
//   { sn: 13, description: "Training-General", debit: "XXX", credit: "" },
//   { sn: 14, description: "Other Services", debit: "XXX", credit: "" },
//   {
//     sn: 15,
//     description: "Consulting and professional services",
//     debit: "XXX",
//     credit: "",
//   },
//   { sn: 16, description: "Fuel and lubricant", debit: "XXX", credit: "" },
//   {
//     sn: 17,
//     description: "Financial charges-General",
//     debit: "XXX",
//     credit: "",
//   },
//   {
//     sn: 18,
//     description: "Miscellaneous expenses general",
//     debit: "XXX",
//     credit: "",
//   },
//   {
//     sn: 19,
//     description: "Grants and other contributions",
//     debit: "XXX",
//     credit: "",
//   },
//   { sn: 20, description: "Cost of IGR Collection", debit: "XXX", credit: "" },
//   { sn: 21, description: "Depreciation", debit: "XXX", credit: "" },
//   { sn: 22, description: "Public debt charges", debit: "XXX", credit: "" },
//   { sn: 23, description: "Other FAAC Deductions", debit: "XXX", credit: "" },
//   {
//     sn: 24,
//     description: "Loss from exchange on foreign debts",
//     debit: "XXX",
//     credit: "",
//   },
//   {
//     sn: 25,
//     description: "Property, plant and Equipment",
//     debit: "XXX",
//     credit: "",
//   },
//   { sn: 26, description: "Investment properties", debit: "XXX", credit: "" },
//   { sn: 27, description: "Investment in securities", debit: "XXX", credit: "" },
//   { sn: 28, description: "Intangible assets", debit: "XXX", credit: "" },
//   { sn: 29, description: "Cash and cash equivalent", debit: "XXX", credit: "" },
//   { sn: 30, description: "Receivables", debit: "XXX", credit: "" },
//   { sn: 31, description: "Inventories", debit: "XXX", credit: "" },
//   { sn: 32, description: "Longterm borrowing", debit: "", credit: "XXX" },
//   { sn: 33, description: "Short term borrowing", debit: "", credit: "XXX" },
//   {
//     sn: 34,
//     description: "Payables and other liabilities",
//     debit: "",
//     credit: "XXX",
//   },
//   { sn: 35, description: "Accumulated Surplus", debit: "", credit: "XXX" },
// ];

const TrialBalanceTable = () => {
  const [ trialBalanceData, setTrialBalanceData ] = useState([]);
  useEffect(() => {
      fetchApi(`get_cash_report?query_type=Trial_Balance&code=220`)
            .then((data) => {
              console.log(data);
              setTrialBalanceData(data.result);
            })
            .catch((err) => {
              console.log(err);
            });
  },[])
  return (
    <div className="container-fluid py-5">
      <style>
        {`
                  h1{
                  font-size: 20px;
                  text-align: center;
                  }
                  .balance{
                  border-bottom: 3px solid black;
                  border-top: 3px solid black;
                  }
                  `}
      </style>
      <h1>TRIAL BALANCE-GENERAL</h1>
      <Table striped hover bordered>
        <thead>
          <tr>
            <th>S/N</th>
            <th>Description</th>
            <th>Account Type</th>
            <th>Debit</th>
            <th>Credit</th>
          </tr>
        </thead>
        <tbody>
          {trialBalanceData.map((item, idx) => (
            <tr key={item.sn}>
              <td className="text-center">{idx + 1}</td>
              <td>{item.description}</td>
              <td>{item.account_type}</td>
              <td className="text-right">
                {item.debit !== 0 ? formatNumber(item.debit) : "-"}
              </td>
              <td className="text-right">
                {item.credit !== 0 ? formatNumber(item.credit) : "-"}
              </td>
            </tr>
          ))}
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td
              className="balance text-right"
              style={{
                borderBottom: "3px solid black",
                borderTop: "3px solid black",
              }}
            >
              {formatNumber(
                trialBalanceData.reduce((acc, item) => acc + item.debit, 0)
              )}
            </td>
            <td
              className="balance text-right"
              style={{
                borderBottom: "3px solid black",
                borderTop: "3px solid black",
              }}
            >
              {formatNumber(
                trialBalanceData.reduce((acc, item) => acc + item.credit, 0)
              )}
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

export default TrialBalanceTable;
